import { Routes } from '@angular/router';

import { hasAccessToModule, hasAccessToSubmodule } from '@guard/roles.guard';
import { Module } from '@type/module.type';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@component/home/home.component').then(component => component.HomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('@component/login/login.component').then(component => component.LoginComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('@component/reset-password/reset-password.component').then(component => component.ResetPasswordComponent),
  },
  {
    path: 'verify-2fa',
    loadComponent: () => import('@component/verify-2fa/verify-2fa.component').then(component => component.Verify2faComponent),
  },
  {
    path: 'set-password',
    loadComponent: () => import('@component/new-password/new-password.component').then(component => component.NewPasswordComponent),
  },
  {
    path: Module.admin,
    canActivate: [hasAccessToModule(Module.admin)],
    canActivateChild: [hasAccessToSubmodule],
    loadChildren: () => import('@component/admin/admin.routes').then(m => m.AdminRoutes),
  },
  {
    path: Module.operator,
    canActivate: [hasAccessToModule(Module.operator)],
    canActivateChild: [hasAccessToSubmodule],
    loadComponent: () => import('@component/operator/operator.component').then(m => m.OperatorComponent),
    loadChildren: () => import('@component/operator/operator.routes').then(m => m.OperatorRoutes),
  },
  {
    path: Module.kms,
    canActivate: [hasAccessToModule(Module.kms)],
    canActivateChild: [hasAccessToSubmodule],
    loadChildren: () => import('@component/kms/kms.routes').then(m => m.KmsRoutes),
  },
  {
    path: '**',
    loadComponent: () => import('@component/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
